/**
 * Dragging a Modal by its header: the rules, kept out of the component so they
 * can be tested without a browser.
 */

/** A press that moves less than this is a click, not a drag. */
export const DRAG_THRESHOLD_PX = 4;

export type Offset = { x: number; y: number };
type Box = { left: number; top: number; width: number; height: number };
type Viewport = { width: number; height: number };

/**
 * Limit a drag so the whole header stays in the window: the box never leaves
 * it sideways (the header is as wide as the box), and vertically the header
 * stays inside while the body may go below the bottom edge. So the header —
 * the drag handle — and its close button are always reachable.
 *
 * `box` is where the box was when the drag started, `headerHeight` its
 * header's height, `move` the pointer's movement since then; the result is the
 * movement to apply.
 */
export function clampDrag(box: Box, headerHeight: number, viewport: Viewport, move: Offset): Offset {
  const x = Math.min(Math.max(move.x, -box.left), viewport.width - box.left - box.width);
  const y = Math.min(Math.max(move.y, -box.top), viewport.height - box.top - headerHeight);
  return { x, y };
}

export function isDrag(move: Offset): boolean {
  return Math.abs(move.x) >= DRAG_THRESHOLD_PX || Math.abs(move.y) >= DRAG_THRESHOLD_PX;
}
